<template>
<div class="text-xs-center">
<v-dialog v-model="likes.modals.deleteSelected" width="450" persistent>

<v-card>
<v-toolbar dark  color="red" flat  height="42">
<v-toolbar-title  > Удаление   из списка активности  </v-toolbar-title>
<v-spacer></v-spacer>
<v-icon @click="likes.modals.deleteSelected = false">mdi-close</v-icon>
</v-toolbar>
<v-card-text scrollable>
Подтвердите удаление элементов в количестве <b>{{likes.selectedSrc.length}}</b>   из списка <span style="color:green">{{likes.selectedCat.name}}</span> отменить данное
действие будет невозможно.
</v-card-text>
<v-divider></v-divider>
<v-card-actions>
<v-spacer></v-spacer>
<v-btn style="text-transform:none"  color="#273C51" small flat @click="likes.modals.deleteSelected = false"> Отмена </v-btn>
<v-btn color="red" small class="white--text" @click="ok()"><v-icon left>mdi-delete</v-icon> Удалить </v-btn>
</v-card-actions>
</v-card>
</v-dialog>
</div>
</template>




<script>
import axios from 'axios'
export default {
props: ['likes'],
data(){
return {

}
},

methods: {
ok(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/post_likes/src_delete.php', {
method: 'POST',
data: {
list: this.likes.selectedSrc,
}
})
.then( response => {
this.likes.modals.deleteSelected = false
this.$router.go()
})
},
}
}
</script>

<style  >

</style>
